/**
 * src/platform/savePdf.web.ts — WEB "download a PDF" (WO-INV1).
 *
 * Web counterpart to savePdf.ts. Fetches the authed invoice PDF as a blob and triggers a browser
 * download (there is no native share sheet on web). Imports NO expo-* native modules.
 *
 * NEVER imports @smartbox/* (mobile invariant 1).
 */
export async function downloadAndSharePdf(
  url: string,
  fileName: string,
  headers: Record<string, string>,
): Promise<void> {
  const res = await fetch(url, { headers, credentials: 'include' });
  if (!res.ok) {
    throw new Error(`Could not download the invoice (HTTP ${res.status}).`);
  }
  const blob = await res.blob();
  const objectUrl = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = objectUrl;
  a.download = fileName;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
}
